module.exports = __webpack_public_path__ + "img/no-course@2x.65beb626.png";